<template>
  <div>
    <hr>
    <footer class="p-4 text-center align-items-center justify-content-center">
    Copyright © {{ new Date().getFullYear() }} - Πόθεν Έσχες
    <!--      Powered by&ndash;&gt;-->
    <!--      <a target="_blank" rel="noopener noreferrer" href="https://www.apt.gr/">-->
    <!--        <img src="../../../assets/images/aptlogo.png" alt="homepage">-->
    <!--      </a>-->
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style>
</style>
